import { render, staticRenderFns } from "./BorrowedStock.vue?vue&type=template&id=b48c7d7a"
import script from "./BorrowedStock.vue?vue&type=script&lang=js"
export * from "./BorrowedStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports